import { useState, useRef } from 'react';
import { useTextPersistence } from "qwanyx";

export const useTextEditor = (qwantumId, onSave, text, persistedText) => {
  const [editable, setEditable] = useState(false);
  const [prevValue, setPrevValue] = useState(text || persistedText || "");
  const textRef = useRef(null);
  const cursorPos = useRef(0);

  const { handleBlur: persistenceBlur } = useTextPersistence(qwantumId, onSave);

  const saveCursorPosition = () => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      cursorPos.current = range.startOffset;
    }
  };

  const restoreCursorPosition = () => {
    if (textRef.current && editable) {
      const selection = window.getSelection();
      const range = document.createRange();
      const textNode = textRef.current.firstChild;
      
      if (textNode) {
        const pos = Math.min(cursorPos.current, textNode.textContent.length);
        range.setStart(textNode, pos);
        range.setEnd(textNode, pos);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  };

  const handleInput = (setProp) => (e) => {
    saveCursorPosition();
    setProp(props => props.text = e.target.textContent);
    setTimeout(restoreCursorPosition, 0);
  };

  const handleBlur = (e) => {
    setEditable(false);
    
    if (qwantumId) {
      const newValue = e.target.textContent;
      
      if (newValue !== prevValue) {
        const syntheticEvent = {
          target: { value: newValue }
        };
        persistenceBlur(syntheticEvent);
        
        if (onSave) {
          onSave(newValue);
        }
        setPrevValue(newValue);
      }
    }
  };

  return {
    editable,
    setEditable,
    textRef,
    handleInput,
    handleBlur
  };
};